import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

const Tag = styled.span`
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

const Style = styled.h1`
  &.CheckoutHeader {
    font-size: 28px;
    font-weight: 600;
    line-height: 20px;
    margin: 0 0 24px 0;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = () => {
  return (
    <HeaderContainer>
      <Tag>Mobile First Checkout</Tag>
      <Style className="CheckoutHeader">
        <FormattedMessage
          defaultMessage="Review and Book"
          description="Main heading for the checkout page where users review their booking details before completing purchase"
        />
      </Style>
    </HeaderContainer>
  );
};
